import styled from '@emotion/styled';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

import { ClientId } from '../../utils/constants';
import { getFeaturesByClientId } from '../../utils/getFeaturesByClientId';
import { usePersistentParameters } from '../../utils/persistParameterContext';

export const StyledWrapper = styled.main<{ $hasPromoBanner?: boolean; $isContactSupport?: boolean }>`
  ${({ theme, $hasPromoBanner, $isContactSupport }) => `
    background-color: ${theme.semantic.BgDefault};
    width: 100%;
    max-width: 100%;
    height:100%;
    min-height: ${$hasPromoBanner ? 'calc(100vh - 81px)' : 'calc(100vh - 20px)'};
    flex:1;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: ${$hasPromoBanner ? '96px 16px 32px' : '102px 0px 46px'};
    box-sizing: border-box;
    

    @media (max-width: 768px) {
      padding: ${$hasPromoBanner ? '24px 16px 24px' : '16px 16px'};
      margin-top: ${$hasPromoBanner ? '36px' : `${theme.semantic.SpaceComponentNone}px`};
      min-height: ${$isContactSupport ? '0px' : $hasPromoBanner ? 'calc(100vh - 60px)' : 'calc(100vh - 16px)'};
      margin-bottom: ${$isContactSupport ? '50%' : '0px'};
    }
  `}
`;

type PageLayoutProps = {
  children: React.ReactNode | React.ReactNodeArray;
  title?: string;
  description?: string;
  testId?: string;
  $hasPromoBanner?: boolean;
  isContactSupport?: boolean;
};

export const PageLayout = ({ children, title, description, testId, isContactSupport }: PageLayoutProps) => {
  const { params } = usePersistentParameters();
  const { isDisplayMGMRewardsPromoBanner } = getFeaturesByClientId(params?.client_id as ClientId);
  useEffect(() => {
    document.querySelector('h1')?.focus();
  }, []);
  return (
    <StyledWrapper
      data-testid={testId}
      $hasPromoBanner={isDisplayMGMRewardsPromoBanner}
      $isContactSupport={isContactSupport}
    >
      <Helmet>
        {title && <title>{title} | MGM Resorts</title>}
        {description && <meta name='description' content={description} />}
      </Helmet>
      {children}
    </StyledWrapper>
  );
};

PageLayout.displayName = 'PageLayout';
